<template>
  <b-overlay
    spinner-variant="primary"
    spinner-type="grow"
    spinner-large
    rounded="lg"
    :show="overlayShow"
  >
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo" to="/">
        <tojtel-logo class="w-100" />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1">
            TojTel - Онлайн магазин номеров и пакетов Babilon-M. 🚀
          </b-card-title>
          <b-card-text class="mb-2">
            Введите свои данные и зарегистрируйтесь.
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="registerForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-register-form mt-2"
              @submit.prevent="confirmPhoneFunc"
            >
              <!-- username -->
              <b-form-group
                label="ФИО"
                label-for="fullname"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ФИО"
                  vid="ФИО"
                  rules="required"
                >
                  <b-form-input
                    id="fullname"
                    name="fullname"
                    v-model="fullname"
                    :state="errors.length > 0 ? false:null"
                    placeholder="ФИО"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- username -->
              <b-form-group
                label="Номер телефона"
                label-for="username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="номер телефона"
                  vid="Номер телефона"
                  rules="required"
                >
                  <b-form-input
                    id="username"
                    v-model="username"
                    name="username"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Номер телефона"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- password -->
              <b-form-group
                label-for="register-password"
                label="Пароль"
              >
                <validation-provider
                  #default="{ errors }"
                  name="пароль"
                  vid="password"
                  rules="required|min:6"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="password"
                      v-model="password"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="errors.length > 0 ? false:null"
                      name="password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>
              <b-form-group
                label-for="confirm-password"
                label="Подтверждение пароль"
              >
                <validation-provider
                  #default="{ errors }"
                  name="подтверждение пароля"
                  vid="Подтверждение пароль"
                  rules="required|confirmed:password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="confirm-password"
                      v-model="confirmPassword"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="errors.length > 0 ? false:null"
                      placeholder="············"
                      autocomplete="off"
                      trim
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox
                  id="register-privacy-policy"
                  v-model="status"
                  name="checkbox-1"
                >
                  Я согласен с
                  <b-link>политика конф. и условия</b-link>
                </b-form-checkbox>
              </b-form-group>

              <b-button
                variant="primary"
                block
                type="button"
                :disabled="invalid"
                @click="confirmPhoneFunc"
              >
                Зарегистрироваться
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>Уже зарегистрировались?</span>
            <b-link :to="{name:'auth-login'}">
              <span>&nbsp;Войдите в систему</span>
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Register-->

      <!-- modal confirm -->
      <validation-observer
        ref="confirmPhoneForm"
        #default="{invalid}"
      >
        <b-form
          class="auth-register-form mt-2"
          @submit.prevent="register"
        >
          <b-modal
            id="modal-confirm"
            centered
            title="Подтверждение номер телефона"
            size="sm"
            v-model="statusConfirmMobileModal"
          >
            <b-alert
              variant="danger"
              v-show="errorMessage.length>0"
            >
              {{errorMessage}}
            </b-alert>
            <b-form-group
              label="Подтверждение номер телефона"
              label-for="confirm-phone"
            >
              <validation-provider
                #default="{ errors }"
                name="Подтверждение номер телефона"
                vid="Подтверждение номер телефона"
                rules="required"
              >
                <b-form-input
                  id="username"
                  v-model="confirmPhone"
                  name="username"
                  type="number"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Номер телефона"
                  autocomplete="off"
                  trim
                  @change="resetCode"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <template #modal-footer>
              <div class="float-right">
                <b-button
                  variant="outline-secondary"
                  class="mr-1"
                >
                  Отмена
                </b-button>
                <b-button
                  variant="primary"
                  type="button"
                  :disabled="invalid || errorMessage.length>0"
                  @click="register"
                >
                  Сохранить
                </b-button>
              </div>
            </template>
          </b-modal>
        </b-form>
      </validation-observer>
      <!-- /modal confirm -->
    </b-row>
  </div>
  </b-overlay>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import TojtelLogo from '@/views/frontend/components/navbar/components/Logo.vue'
import {
  BOverlay, BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import ru from 'vee-validate/dist/locale/ru.json'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BOverlay,
    TojtelLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      fullname: '',
      username: '',
      password: '',
      confirmPassword: '',
      confirmPhone: '',
      overlayShow: false,
      statusConfirmMobileModal: false,
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email,
      errorMessage: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    register() {
      this.$refs.confirmPhoneForm.validate().then(success => {
        if (success) {
          this.overlayShow = true
          useJwt.register({
            username: this.username,
            fullname: this.fullname,
            password: this.password,
            code: this.confirmPhone,
          })
            .then(() => {
              this.$router.replace('/login')
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Успешно зарегистрированы!',
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: 'Вы успешно зарегистрированы, чтобы войти в систему ждите подтверждение администратора.',
                    },
                  })
                })
                .catch(error => {
                  this.$refs.loginForm.setErrors(error.response.data.error)
                })
              this.overlayShow = false
            })
            .catch(error => {
              this.errorMessage = error.response.data.error
              this.overlayShow = false
            })
        }
      })
    },
    confirmPhoneFunc() {
      this.statusConfirmMobileModel = true
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          this.overlayShow = true
          useJwt.confirmPhone({
            phone: this.username,
          }).then(response => {
            if (response.data === 1) {
              this.statusConfirmMobileModal = true
            }
            this.overlayShow = false
          })
            .catch(error => {
              this.$refs.registerForm.setErrors(error.response.data.error)
              this.overlayShow = false
            })
        }
      })
    },
    resetCode() {
      this.errorMessage = ''
    },
  },
  created() {
    localize('ru', ru)
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
